const hardwareActionBaseClassName =
  "h-11 min-w-20 !rounded-sm !border px-3 !text-xs !uppercase tracking-wide !shadow-none transition duration-200 ease-out hover:-translate-y-0.5 hover:!shadow-lg motion-reduce:transform-none motion-reduce:transition-none sm:h-10";

/** Shared visual recipe for compute-detail actions across button implementations. */
export const hardwareActionClassNames = {
  neutral: `${hardwareActionBaseClassName} !border-zinc-700 !bg-transparent !text-zinc-300`,
  primary: `${hardwareActionBaseClassName} !border-highlight !bg-highlight !text-black`,
  danger: `${hardwareActionBaseClassName} !border-red-700/60 !bg-transparent !text-red-400`,
} as const;
